/**
 * PC版の設定の2列（#153、docs/62 §6）。components/SettingsLayout.tsx が右の画面に渡す。
 *   twoCol＝2列の右の画面（PC版の /settings/*）、top＝左の列に行がある画面（「‹ 設定」を出さない＝BackButton が描かない。左の列が戻り道）
 * BackButton と SettingsLayout が互いを読み込まないよう、ここに分けた
 */
import { createContext, useContext } from "react";

export type SettingsPane = { twoCol: boolean; top: boolean };
export const SettingsPaneContext = createContext<SettingsPane>({ twoCol: false, top: false });
export const useSettingsPane = (): SettingsPane => useContext(SettingsPaneContext);
